import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", {
        disabled: _ctx.isDisabled,
        primaryLarge: _ctx.size === 'large',
        primaryNormal: _ctx.size === 'normal',
        primarySmall: _ctx.size === 'small',
        primary: _ctx.type === 'primary',
        outlined: _ctx.type === 'outlined',
        text: _ctx.type === 'text'
      }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    onTouchstartPassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
    style: _normalizeStyle(_ctx.styleObject)
  }, _toDisplayString(_ctx.text), 39))
}